/**
 * In this section, we are declaring a GLOBAL mixin; keep in mind that EVERYTHING
 * included here WILL BE ADDED to every single component in the App
 */

Vue.mixin({

    methods: {

        logout() {

            axios.post('/:language/logout')
                .then(function (response) {
                    // router.push('/');
                    window.location.href = '/:language/login';
                    /*console.log('Succeeded Login Out: ' + response);*/
                })
                .catch(function (error) {
                    // Wu oh! Something went wrong
                    console.log(error.message);
                });

        }
    }

})

/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries.
 */

import './bootstrap';
import './EventDispatcher';
import router from './routes';

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

const files = require.context('./', true, /\.vue$/i)
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

import { isMobileOnly } from 'mobile-device-detect';
import { isTablet } from 'mobile-device-detect';

let store = {

    scrollops: {
        vuescroll: {
            mode: 'native',
            detectResize: true,
        },
        scrollPanel: {
            initialScrollY: false,
            initialScrollX: false,
            scrollingX: false,
            scrollingY: true,
            speed: 300,
            easing: 'easeInQuad',
            verticalNativeBarPos: 'right'
        },
        rail: {
            background: '#8c8c8c',
            opacity: 0.2,
            size: '8px',
            specifyBorderRadius: false,
            gutterOfEnds: null,
            gutterOfSide: '2px',
            keepShow: false
        },
        bar: {
            showDelay: 500,
            onlyShowBarOnScroll: false,
            keepShow: false,
            background: '#9a9a9a',
            opacity: 0.75,
            hoverStyle: false,
            specifyBorderRadius: false,
            minSize: 0,
            size: '8px',
            disable: false
        }
    },

    sidebar_visible: true,
    theme: 'theme-dark',
    themeLabel: Laravel.language === 'es' ? 'Claro' : 'Light',
    themeIcon: 'wb_sunny',
    contentViewVisible: false,
    _isMobileOnly: isMobileOnly,
    _isTablet: isTablet,

    playerPayload: '',
    playerCategories: '',

    full_comment_data: [],

    contentPlays: '000',
    contentLikes: '000',
    contentDislikes: '000',
    mobileSearchVisible: false,
    isLegacyContent: false,
    helpersVisible: false,

    tagBarSelectedTag: '',

    collapsedCategories: true,
    collapsedAdmin: true,
    groupKey: Array.from(Array(100).keys()),

    playlistAdminVisible: false,
    playlistChooserVisible: false,

    playlistsViewVisible: false,
    isWatchLaterEnabled: false,

    userWatchLaterList: '',
    userPlaylistsCollection: '',

    playlistViewPayload: '',
    preselectedPlaylist: '',

    contentIdToAddToPlaylist: '',

    avatarsVisible: false,

    // This value will retain the user's current page right before opening any
    // content; this will serve the purpose of reverting the browser's address
    // bar URL to its former value, since opening a player view will replace
    // the address bar content with that content's URL. Upon closing the Player
    // view, this value will be used to revert that URL to its previous state
    previousPageURL: '',

    // These hold state for the AutoPlay feature of the Coming Up module
    autoplayIsEnabled: false,
    autoplayItemIndex: 0,
    currentlyPlayingContentId: '',
    comingUpContentCollection: ''

};

const app = new Vue({

    el: '#app',

    router,

    data: {
        sidebar_vis_class: 'home-sidebar shadow-2xl w-56 invisible md:visible scrolling-touch',
        /*content_vis_class: 'main-content ml-0 md:ml-56 md:pt-16 md:main-content-mid disable-scrollbars',*/
        content_vis_class: 'main-content ml-0 md:ml-56 md:pt-16 md:main-content-mid overflow-y-scroll',
        player_vis_class: 'absolute w-full h-full transform transition-all duration-200 hidden',
        shared: store,

        errors: [],
        registerEmail: null,
        currentLocale: Laravel.language,

    },

    /*props: [

        'isDirectLink',
        'incomingContent'

    ],*/

    computed: {

        getSidebarClasses: {

            get: function () {
                return this.sidebar_vis_class;
            },

            set: function (value) {

                if(store.sidebar_visible) {
                    /*console.log('Setting the sidebar classes for visible state...');*/
                    this.sidebar_vis_class = 'home-sidebar shadow-2xl md:visible w-56 transform transition-all duration-200';
                } else {
                    /*console.log('Setting the sidebar classes for invisible state...');*/
                    this.sidebar_vis_class = 'home-sidebar shadow-2xl invisible md:visible w-20 transform transition-all duration-200';
                }
            }
        },

        getContentClasses: {

            get: function () {
                return this.content_vis_class;
            },

            set: function (value) {

                if(store.sidebar_visible) {
                    this.content_vis_class = 'main-content md:pt-16 ml-0 md:main-content-mid disable-scrollbars md:ml-56 transform transition-all duration-200';
                } else {
                    this.content_vis_class = 'main-content md:pt-16 ml-0 md:main-content-mid disable-scrollbars md:ml-20 transform transition-all duration-200';
                }
            }
        }
    },

    methods: {

        clickOnPlayerModal: function(event) {

            store.contentViewVisible = false;
            this.setPlayerInvisible();

        },

        showAvatars() {
            store.avatarsVisible = true
        },

        clearWatchLater(message) {

            if(confirm(message)) {
                window.location = '/' + this.currentLocale + '/watchlater/clear'
            }

        },

        clearHistory(message) {

            if(confirm(message)) {
                window.location = '/' + this.currentLocale + '/history/clear'
            }

        },

        showPlaylistAdmin() {
            store.playlistAdminVisible = true
        },

        showPlaylistChooser() {
            store.playlistChooserVisible = true
        },

        toggleCollapsedCategories() {
            store.collapsedCategories = !store.collapsedCategories
        },

        toggleCollapsedAdmin() {
            store.collapsedAdmin = !store.collapsedAdmin
        },

        setSideBarOpen() {
            store.sidebar_visible = true;
            this.getSidebarClasses = store.sidebar_visible;
            this.getContentClasses = store.sidebar_visible;
            /*console.log('Method setSideBarOpen was invoked!');*/
        },

        setSideBarClosed() {
            store.sidebar_visible = false;
            this.getSidebarClasses = store.sidebar_visible;
            this.getContentClasses = store.sidebar_visible;
            /*console.log('Method setSideBarClosed was invoked!');*/
        },

        toggleSideBar() {

            store.sidebar_visible = !store.sidebar_visible;

            this.getSidebarClasses = store.sidebar_visible;
            this.getContentClasses = store.sidebar_visible;

            /*console.log('Method toggleSideBar was invoked!');*/
        },

        switchSiteLanguage(languageReceived) {

            /*console.log('Received: ' + languageReceived);*/

            if(languageReceived==='en') {
                window.location = 'https://videos.telesurtv.net';
            } else {
                window.location = 'https://videos.telesurenglish.net';
            }

        },

        setPlayerVisible() {
            /*console.log('Setting Player as VISIBLE');*/
            store.contentViewVisible = true
            this.player_vis_class = ''
            /*console.log('player_vis_class: ' + this.player_vis_class);*/
        },

        setPlaylistsViewVisible() {
            /*console.log('Setting Player as VISIBLE');*/
            store.playlistsViewVisible = true;
            this.player_vis_class = ''
            /*console.log('player_vis_class: ' + this.player_vis_class);*/
        },

        showPlaylistsViewPreselected(playlistId, playlistName) {
            /*console.log('Setting Playlists View with ID: ' + playlistId + ' - ' + playlistName)*/
            store.preselectedPlaylist = { id: playlistId, name: playlistName }

            let userId = window.Laravel.user.id
            this.$root.shared.playerPayload = ''
            Event.fire('showPlaylistsView', { language: this.currentLocale, data: { userId: userId, isWatchLater: false } });

/*            store.playlistsViewVisible = true
            this.player_vis_class = ''*/
            /*console.log('player_vis_class: ' + this.player_vis_class);*/
        },

        setMobilePlayerVisible() {

            store.contentViewVisible = true
            this.player_vis_class = ''

        },

        setPlayerInvisible() {
            /*console.log('Setting Player as INVISIBLE');*/
            store.contentViewVisible = false
            this.player_vis_class = 'hidden'
            /*console.log('player_vis_class: ' + this.player_vis_class);*/
        },

        setPlaylistViewInvisible() {
            /*console.log('Setting Player as INVISIBLE');*/
            store.playlistsViewVisible = false
            this.player_vis_class = 'hidden'
            /*console.log('player_vis_class: ' + this.player_vis_class);*/
        },

        alertMe() {
            alert('me')
        },

        doTheThing() {
            Event.fire('toggleTheme')
        },

        checkEmail: function(e) {

            this.errors = [];

            if (!this.validEmail(this.registerEmail)) {
                if (this.currentLocale==='en') {
                    this.errors.push('Valid email required.');
                } else {
                    this.errors.push('Se requiere una dirección de e-mail válida.');
                }


            }

            if (!this.errors.length) return true;

            e.preventDefault();

        },

        validEmail: function (email) {
            // let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            let re = /\S+@\S+\.\S+/;

            return re.test(email);
        }

        /*setContentViewVisibility(state) {
            store.contentViewVisible = state;
        }*/
    },

    mounted() {

        /*if(store._isMobileOnly || store._isTablet) {*/
        if(store._isMobileOnly) {
            this.setSideBarClosed();
        }
        /*console.log('At MAIN mounted() time, sidebar_visible is: ' + store.sidebar_visible);*/

        /*Event.listen('showPlayer', (request) => {


            console.log('============================ SHOWPLAYER RECEIVED: ' + JSON.stringify(request.language));



        });*/

        Event.listen('showPlayer', (request) => {

            /*console.log('============================ SHOWPLAYER RECEIVED: ' + request.language + ', ' + JSON.stringify(request.data));*/

            axios.get('/api/content/data/' + request.language + '/' + request.data.id)
                .then(response => {
                    this.setPlayerVisible();
                    store.playerCategories = response.data;
                    store.playerPayload = request.data;
                    store.isLegacyContent = !!request.data.legacy;

                    // Get the Content Stats
                    axios.get('/api/content/stats/' + request.data.id)
                        .then(response => {
                            store.contentPlays = response.data.plays;
                            store.contentLikes = response.data.likes;
                            store.contentDislikes = response.data.dislikes;
                        })
                        .catch(error => {
                            console.log('ERROR Getting Content Stats! ' + error);
                            store.contentPlays = '---';
                            store.contentLikes = '---';
                            store.contentDislikes = '---';
                        });

                    // Set the content Id as the currently "playing" item
                    store.currentlyPlayingContentId = request.data.id

                    // Get the Content Comments
                    axios.get('/api/comments/' + request.data.id)
                        .then((response) => {
                            store.full_comment_data = response.data
                        })
                        .catch((error) => {
                            console.log('Error obtaining COMMENTS data: ' + error)
                        })

                })
                .catch(error => {
                    console.log('Error getting categories... :-(')
                });

        });

        Event.listen('showPlayerMobile', (request) => {


            /*console.log('Showing mobile player with: ' + JSON.stringify(receivedPlayerPayload));*/
            /*console.log('Showing mobile player with: ' + request.data.filename);*/

            axios.get('/api/content/data/' + request.language + '/' + request.data.id)
                .then(response => {
                    /*this.setPlayerVisible();*/
                    this.setMobilePlayerVisible();

                    store.playerCategories = response.data;
                    store.playerPayload = request.data;

                    store.isLegacyContent = !!request.data.legacy;
                    /*store.isLegacyContent = false;*/

                    // Get the Content Stats

                    if(request.data.legacy) {

                        axios.get('/api/content/legacy/stats/' + request.data.id)
                            .then( response => {
                                store.contentPlays = response.data.plays;
                                store.contentLikes = response.data.likes;
                                store.contentDislikes = response.data.dislikes;
                            })
                            .catch( error => {
                                console.log('ERROR Getting Content Stats! ' + error);
                                store.contentPlays = '---';
                                store.contentLikes = '---';
                                store.contentDislikes = '---';
                            });

                    } else {

                        axios.get('/api/content/stats/' + request.data.id)
                            .then(response => {
                                store.contentPlays = response.data.plays;
                                store.contentLikes = response.data.likes;
                                store.contentDislikes = response.data.dislikes;
                            })
                            .catch(error => {
                                console.log('ERROR Getting Content Stats! ' + error);
                                store.contentPlays = '---';
                                store.contentLikes = '---';
                                store.contentDislikes = '---';
                            });
                    }

                    /*console.log('For mobile player ------> ' + JSON.stringify(store.playerPayload))*/
                })
                .catch(error => {
                    console.log('Error getting categories... :-(')
                });

        });


        Event.listen('showPlaylistsView', (request) => {

            // Fire up the HIDE events in case the view is already open

            Event.fire('hidePlaylistView');

            // What needs to happen here:
            // - We get the user from the Request object
            // - We execute a call to the Controller in order to get the Playlists collection(s)
            // - We get the necessary Content piece of Content and initialize the Player
            // - We then make the view appear

            axios.get('/' + request.language + '/profile/playlists/' + request.data.userId)
                .then((response) => {

                    // The response Object carries an array where:
                    // - The FIRST [0] element is the Watch Later Playlist for the User WITH it's content references
                    // - The SECOND [1] element contains another array with references to all the User's Playlists and
                    //   their content; so, the first non-WatchLater playlist is at index [1][0], and therefore, its
                    //   Content payload can be accessed from the given array;
                    // - We will fetch the first Content piece according to whether the user selected the Watch Later
                    //   or the Playlists option

                    let firstContentId = ''

                    if (request.data.isWatchLater) {

                        if(response.data[0]) {

                            if (response.data[0].contents[0]) {
                                firstContentId = response.data[0].contents[0].id
                            } else {
                                firstContentId = ''
                            }

                        } else {
                            firstContentId = ''
                        }

                        store.isWatchLaterEnabled = true

                    } else {

                        if(response.data[1].length > 0) {

                            if (response.data[1][0].contents[0]) {
                            /*if (response.data[1][0].contents.length > 0) {*/
                                firstContentId = response.data[1][0].contents[0].id
                                if(store.preselectedPlaylist.name === 'default') {
                                    store.preselectedPlaylist = {
                                        id: response.data[1][0].id,
                                        name: response.data[1][0].name
                                    }
                                }
                            } else {
                                firstContentId = ''
                            }

                        } else {
                            firstContentId = ''
                        }
                        /*console.log(firstContentId)*/
                        store.isWatchLaterEnabled = false
                    }

                    // At this point, we have both the Watch Later and the Playlists Collection for the user,
                    // so we need to make those available to the Playlists View Component

                    store.userWatchLaterList = response.data[0]
                    store.userPlaylistsCollection = response.data[1]

                    // Now that we MAY have a Content ID, let's fetch the Actual Content
                    // and if we don't, skip
                    if (firstContentId !== '') {

                        let theFirstContent = ''

                        axios.get('/api/content/' + firstContentId)
                            .then((response) => {
                                theFirstContent = response.data
                            })
                            .catch((error) => {
                                console.log('ERROR fetching the piece of Content while initializing the Playlists View: ' + error)
                            })

                        axios.get('/api/content/data/' + request.language + '/' + firstContentId)
                            .then(response => {
                                this.setPlaylistsViewVisible();
                                store.playerCategories = response.data;
                                store.playerPayload = theFirstContent;
                                store.isLegacyContent = !!theFirstContent.legacy;

                                // Get the Content Stats
                                axios.get('/api/content/stats/' + firstContentId)
                                    .then(response => {
                                        store.contentPlays = response.data.plays;
                                        store.contentLikes = response.data.likes;
                                        store.contentDislikes = response.data.dislikes;
                                    })
                                    .catch(error => {
                                        console.log('ERROR Getting Content Stats! ' + error);
                                        store.contentPlays = '---';
                                        store.contentLikes = '---';
                                        store.contentDislikes = '---';
                                    });

                                // Get the Content Comments
                                axios.get('/api/comments/' + firstContentId)
                                    .then((response) => {
                                        store.full_comment_data = response.data
                                    })
                                    .catch((error) => {
                                        console.log('Error obtaining COMMENTS data: ' + error)
                                    })

                            })
                            .catch(error => {
                                console.log('Error getting categories... :-(')
                            });

                    } else {
                        store.playerPayload = ''
                        this.setPlaylistsViewVisible()
                    }

                })
                .catch((error) => {
                    store.playerPayload = ''
                    console.log('ERROR trying to get the User\'s Playlists: ' + error)
                })

        });


        Event.listen('playWatchLaterItem', (request) => {

            axios.get('/api/content/data/' + request.language + '/' + request.data.id)
                .then(response => {

                    store.playerCategories = response.data;
                    store.playerPayload = request.data;
                    store.isLegacyContent = !!request.data.legacy;

                    // Get the Content Stats
                    axios.get('/api/content/stats/' + request.data.id)
                        .then(response => {
                            store.contentPlays = response.data.plays;
                            store.contentLikes = response.data.likes;
                            store.contentDislikes = response.data.dislikes;
                        })
                        .catch(error => {
                            console.log('ERROR Getting Content Stats! ' + error);
                            store.contentPlays = '---';
                            store.contentLikes = '---';
                            store.contentDislikes = '---';
                        });

                    // Get the Content Comments
                    axios.get('/api/comments/' + request.data.id)
                        .then((response) => {
                            store.full_comment_data = response.data
                        })
                        .catch((error) => {
                            console.log('Error obtaining COMMENTS data: ' + error)
                        })

                })
                .catch(error => {
                    console.log('Error getting categories... :-(')
                });


        });


        Event.listen('showMobileSearch', () => {
            /*console.log('Setting Mobile Search to VISIBLE');*/
            store.mobileSearchVisible = true;
        });

        Event.listen('hideMobileSearch', () => {
            /*console.log('Setting Mobile Search to INVISIBLE');*/
            store.mobileSearchVisible = false;
        });

        Event.listen('toggleHelpersVisible', () => {
            store.helpersVisible = !store.helpersVisible;
        });

        Event.listen('hidePlayer', () => {
            /*console.log('Setting Player as HIDDEN');*/
            store.contentViewVisible = false;
            this.setPlayerInvisible();
        });

        Event.listen('hidePlaylistView', () => {
            /*console.log('Setting Player as HIDDEN');*/
            store.playlistsViewVisible = false;
            this.setPlaylistViewInvisible();
        });

        Event.listen('editContentWasPressed', (received) => {

            let tmpContent = '';
            let tmpCats = '';

                axios.get('/api/content/' + received.contentId)
                    .then(receivedPayload => {
                        tmpContent = receivedPayload.data;
                        store.playerPayload = tmpContent;
                    })
                    .catch(error => {
                        console.log('Error getting CONTENT package... :-(  Message: ' + error);
                        /*alert('Got this ERROR on CONTENT Package: ' + JSON.stringify(error));*/
                    })
                    .then(() => {
                        axios.get('/api/content/data/' + received.contentId)
                            .then(response => {
                                tmpCats = response.data;
                                store.playerCategories = tmpCats;
                            })
                            .catch(error => {
                                console.log('Error getting CATEGORIES package... :-(  Message: ' + error);
                                alert('Got this ERROR on Categories Package: ' + JSON.stringify(error));
                            });
                    })
                    .then(() => {

                    })

        });

    },

    created() {

        // Set the initial theme based on what is (probably) stored on the client
        store.theme = localStorage.getItem('theme') || 'theme-dark';

        if(Laravel.language==='es') {
            store.themeLabel = store.theme === 'theme-light' ? 'Oscuro' : 'Claro';
        } else {
            store.themeLabel = store.theme === 'theme-light' ? 'Dark' : 'Light';
        }
        store.themeIcon = store.theme === 'theme-light' ? 'brightness_2' : 'wb_sunny';

        // Set the initial AutoPlay mode for Coming Up content based on what is (probably) stored on the client
        store.autoplayIsEnabled = JSON.parse(localStorage.getItem('autoplay')) || localStorage.setItem('autoplay', JSON.stringify(false));
        store.autoplayIsEnabled = JSON.parse(localStorage.getItem('autoplay'))

        // Event handlers to globally manage these pieces of state
        Event.listen('toggleTheme', function () {
            /*console.log('We got to the listener... current theme: ' + store.theme);*/
            store.theme = store.theme === 'theme-light' ? 'theme-dark' : 'theme-light';
            if(Laravel.language==='es') {
                store.themeLabel = store.theme === 'theme-light' ? 'Oscuro' : 'Claro';
            } else {
                store.themeLabel = store.theme === 'theme-light' ? 'Dark' : 'Light';
            }
            store.themeIcon = store.theme === 'theme-light' ? 'brightness_2' : 'wb_sunny';
            /*console.log('Switching theme to: ' + store.theme + ' and storing the preference.');*/
            localStorage.setItem('theme', store.theme);
        });

        Event.listen('toggleAutoplay', function () {
            // Toggle the Autoplay value and store it for the user's browser session
            store.autoplayIsEnabled = !store.autoplayIsEnabled;
            localStorage.setItem('autoplay', JSON.stringify(store.autoplayIsEnabled));

        });


        Event.listen('closeSidebar', function () {
            /*console.log('closeSidebar Event was FIRED!');*/
            // store.sidebar_visible = false;
            store.sidebar_visible = false;
            this.getSidebarClasses = store.sidebar_visible;
            this.getContentClasses = store.sidebar_visible;
        });

    }

});
